export default "__VITE_ASSET__WmcCDhKy__"